import { _URL } from "../../config.json";
import http from "../http";

const apiEndpoint = _URL + "/api/Auth/ResetPassword";

export function ResetPassword(obj) {
  return http.post(apiEndpoint, obj);
}
